<script setup>
import { computed, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import Sidebar from "@/examples/Sidebar/Sidebar.vue";
import Navbar from "@/examples/Navbars/CustomNavbar.vue";
import TransferNavbar from "@/examples/Navbars/TransferNavbar.vue";
import SessionTimeoutModal from "@/components/SessionTimeoutModal.vue";
import { setBrandTitle } from "@/utils/branding";

const store = useStore();
const route = useRoute();

const isOtpPage = computed(() => route.name === "Otp");
const isAuthRoute = computed(
  () => route.path.includes("/sign-in") || route.path.includes("/auth")
);

const showTransferNavbar = computed(() => store.state.showTransferNavbar);
const showNavbar = computed(() => store.state.showNavbar);
const showSidebar = computed(() => store.state.showSidenav);

watch(
  route,
  () => {
    const isAuthOrOtp = isAuthRoute.value || isOtpPage.value;
    store.commit("setShowNavbar", !isAuthOrOtp);
    store.commit("setShowSidenav", !isAuthOrOtp);
  },
  { immediate: true }
);

// Check for existing token on app mount
onMounted(() => {
  // Set dynamic title based on domain
  setBrandTitle();
  
  const token = localStorage.getItem('auth_token');
  if (token && !store.state.auth.token) {
    // Restore token to store and start session timeout
    store.dispatch('auth/setUserToken', token);
    console.log('Restored user session from localStorage');
  }
});
</script>

<template>
  <div class="app-container">
    <router-view v-if="isOtpPage || isAuthRoute" />
    <div v-else class="main-layout">
      <Navbar v-if="showNavbar" class="fixed-navbar" />
      <TransferNavbar v-if="showTransferNavbar" class="fixed-navbar" />
      <div class="layout-body">
        <Sidebar v-if="showSidebar" />
        <div class="content-area">
          <div class="main-content">
            <router-view />
          </div>
        </div>
      </div>
    </div>
    
    <!-- Session Timeout Modal - Global -->
    <SessionTimeoutModal />
  </div>
</template>

<style scoped>
.app-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.main-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.fixed-navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.layout-body {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.content-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.main-content {
  flex-grow: 1;
  overflow-y: auto;
}
</style>
